<template>
  <transition-group name="modal">
    <div class="modal-mask" :key="'mask'" @click.once="$emit('closeModal')">
      <div
        class="modal-container"
        :class="$mq"
        :key="'modal-1'"
        @click.stop.prevent=""
      >
        <div class="modal-body flex flex-wrap justify-center">
          <div class="flex justify-center flex-col">
            <slot name="body">
              <h3 class="text-center pb-4">
                {{ ta('exit.prompt') }}
              </h3>
              <button
                class="btn btn-novacair-selected"
                @click="$emit('closeScreening')"
              >
                {{ ta('exit.confirm') }}
              </button>
            </slot>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-novacair-light" @click="$emit('closeModal')">
            {{ ta('exit.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
import { adminI18n } from '@/i18n';

export default {
  name: 'QuestionModal',
  props: [],
  methods: {
    ta(key) {
      return adminI18n.t(key);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/modal.scss';

.password {
  font-family: $font-family-password;
}
</style>
